import { Modal } from './a11y-modal';

export class WordflyModal extends Modal {
    constructor(modalElement: HTMLElement, container?: HTMLElement) {
        super(modalElement, container);
        
        this.modal.on('hide', () => {
            this.triggerWordflyApi();
        });

        this.handleListener();
    }

    handleListener() {
        const signupButton = this.modalElement.querySelector('#wordflySubmit');
        const input = this.modalElement.querySelector('#wordfly-email') as HTMLInputElement;
        if (signupButton) {
            signupButton.addEventListener('click', () => {
                if (input.value != '') {
                    this.modal.hide();
                }
            });
        }
    }

    async triggerWordflyApi(): Promise<void> {
        try {
            await fetch('/umbraco/api/OnTheCornerApi/CloseSignUpModal', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
        } catch (error) {
            console.error('Error closing sign up modal:', error);
        }
    }
}